import { QueryClient } from '@tanstack/react-query';

const dirtyKey = (queryKey: readonly unknown[]): readonly unknown[] => [...queryKey, '__dirty__'] as const;

export const markQueryDirty = (queryClient: QueryClient, queryKey: readonly unknown[]): void => {
  queryClient.setQueryData(dirtyKey(queryKey), true);
  queryClient.invalidateQueries({ queryKey, refetchType: 'none' });
};

export const consumeQueryDirty = (queryClient: QueryClient, queryKey: readonly unknown[]): boolean => {
  const isDirty = Boolean(queryClient.getQueryData(dirtyKey(queryKey)));
  if (isDirty) {
    queryClient.setQueryData(dirtyKey(queryKey), false);
  }
  return isDirty;
};
